import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";
import { Button, Modal, FormControl } from "react-bootstrap";
import ResetEmail from "../AccountManagement/ResetEmail";
//css
import "../../assets/css/maincss.css";
import "../../assets/css/header.css";

//IMG
import PencilIcon from "../../assets/img/pencil.png";

import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    // changePasswordButtonTitle: "Change Password",
    changeEmailTitle: "Change Email",
  },
  ja: {
    // changePasswordButtonTitle: "パスワード変更",
    changeEmailTitle: "メールアドレスード変更",
  },
  es: {
    // changePasswordButtonTitle: "Cambiar Contraseña",
    changeEmailTitle: "Cambiar Correo Electrónico",
  },
});

class EmailSetting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showPopup: false,
    };

    //? Functions
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentWillMount() {
    //! LANGUAGE SETTING
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }

  handleShow() {
    this.setState({
      showPopup: true,
    });
    // this.setState({
    //   showPopup: true
    // });
  }

  handleClose() {
    this.setState({
      showPopup: false,
    });
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    return (
      <a>
        <img
          className="pencilIconStyle"
          src={PencilIcon}
          alt="pencil.jpg"
          onClick={this.handleShow}
        />

        <Modal
          show={this.state.showPopup}
          onHide={this.handleClose}
          keyboard={false}
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>{localizationStrings.changeEmailTitle}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <ResetEmail />
          </Modal.Body>
        </Modal>
      </a>
    );
  }
}

export default EmailSetting;
